export const getPropertyDocuments = (property) => {
	// if (!property) {
	// 	return [];
	// }

	return {
		'Property Records & Documentation': [
			'Asbestos Reports',
			'Comprehensive Property Report',
			'Deeds',
			'Docket Book',
			'Easements',
			'Endorsements / Restrictions',
			'Energy Efficiency',
			'Equipment Use Permits',
			'Health Grade',
			'Historical Images',
			'Letter of No Objection',
			'Property Card',
			'Public Assembly',
			'Sewer Map',
			'Surveys',
			'Temporary Use Permit',
			'Title Report',
			'Zoning Declarations & Exhibits',
		],
		'Structural & Construction': [
			'Concrete – Cast-in-Place',
			'Concrete – Precast / Prestressed',
			'Excavations – Sheeting/Shoring/Bracing',
			'Footing & Foundation',
			'Helical Piles',
			'Lowest Floor Elevation',
			'Masonry',
			'Preliminary Progress Inspection',
			'Raising/Moving of a Building',
			'Retaining wall inspection Cycle 1 and Cycle 2 LL 37/2008 TR16',
			'Structural Cold-Formed Steel',
			'Structural Stability – Existing Buildings',
			'Structural Steel – Details',
			'Structural Steel – High-Strength Bolting',
			'Structural Steel – Welding',
			'Structural Wood Frame',
			'Subgrade / Subsurface – Fill & Density',
			'Subsurface Investigations',
			'Vertical Masonry Foundations',
			'Wood – High-Load Diaphragms',
			'Wood – Metal-Plate-Connected Trusses',
			'Wood – Prefabricated I-Joists',
		],
		'Fire': [
			'Emergency & Standby Power / Generators (Weekly, Monthly)',
			'Emergency Lighting & Exit Signs Testing',
			'Façade / FISP (Cycle reports, SWARMP, observations)',
			'FDNY Annual Fire Safety Inspection',
			'FDNY Refrigeration System Permit',
			'Fire Alarm Testing (Semi-Annual / Annual – NFPA 72)',
			'Fire Door Annual Inspection (NFPA 80)',
			'Fire Pump Testing (Weekly Run / Annual Flow Test)',
			'Fire-Resistive Penetrations & Joints',
			'Fire-Resistance-Rated Construction',
			'Kitchen Hood & Duct Cleaning',
			'Kitchen Hood Suppression',
			'Luminous Egress Path Markings',
			'Place of Assembly (PA) Permit (renewal)',
			'Portable Fire Extinguishers',
			'Self-Closing Doors (Entry/Apt)',
			'Smoke Control Systems',
			'Sprayed Fire-Resistant Materials',
			'Sprinkler – (Owner Visual, Quarterly Inspection/Test, Annual Inspection/Test)',
			'Standpipe – 5-Year Hydrostatic Test / Acceptance',
		],
		'Mechanical, Plumbing & Fuel': [
			'Chimneys',
			'Exhaust/Vent in Plenums',
			'Fuel Oil Storage, Piping & Burner Permit',
			'Gas Piping Periodic Inspection',
			'HP Steam/HTHW/Fuel-Gas Piping (Welding)',
			'Mechanical Demolition',
			'Mechanical Systems',
		],
		'Energy, Environment & Health': [
			'Alternative Materials (OTCR)',
			'Asbestos Investigations',
			'Cooling Towers – Routine & Annual (LL77)',
			'DEP Boiler Emissions / Certificate to Operate',
			'DEP Right-to-Know (Hazardous Substances) (Annual Chemical Inventory)',
			'DOHMH Drinking Water Storage Tank',
			'DOHMH Swimming Pool Health Inspection',
			'DSNY Recycling / Containerization',
			'Energy Audit & Retro-Cx',
			'Energy Code Progress (TR8)',
			'Flood Zone Compliance',
			'Noise Code – Sound Level Inspection (DEP)',
			'Private On-Site Stormwater / Detention',
			'Rodent Control (Exterior) – Inspections',
			'Tenant Protection Plan Compliance',
		],
		'Housing, Tenant & HPD': [
			'Heat & Hot Water (HMC) (HPD)',
			'HPD Indoor Allergen Hazards (Mold & Pests, LL55)',
			'Lead Paint Compliance (Annual In-Unit, One-time XRF Survey)',
			'Window Guards – Annual Notice & Verification',
		],
		'Special Inspections & Progress': [
			'Intumescent/Mastic Coatings',
			'LL 92/94 Sustainable roof zone reports and inspections',
			'Parapet inspections LL126',
			'Parking Structures – PIPS',
			'Periodic Elevator/Escalator inspections, CAT 1, CAT 5 for passenger, freight, sidewalk, escalator, accessibility lift, dumbwaiter, material lift, man lift, moving walk',
			'Post-Installed Anchors',
			'Seismic Isolation Systems',
			'Special and Progress Inspections and Tests Chapter 17 NYC BC',
			'Wall Panels, Curtain Walls, Veneers',
		],
		'Other / General Compliance': [
			'Backflow Preventer – Annual Test',
			'Combustible Exterior Wall Coverings',
		],
	};

	//todo: move links to links

	// return {
	// 	"I-Card": { link: "https://hpdonline.hpdnyc.org/HPDonline/provide_address.aspx?p1="+ property.borough +"&p2="+ property.house_number +"&p3=" + property.street_name },
	// 	"Certificate of Occupancy": { link: "http://a810-bisweb.nyc.gov/bisweb/COsByLocationServlet?requestid=0&allbin=" + property.bin },
	// 	// "Landmark Designation Report": { prompt: true },
	// 	"Landmark Designation Report": { link: 'https://www1.nyc.gov/site/lpc/designations/designation-reports.page' },

	// 	"Letter of No Objection": { prompt: true },
	// 	"Temporary Use Permit": { prompt: true },
	// 	"Building Card": { prompt: true },
	// 	"Sanborn Map": { prompt: true },
	// 	"Historical Images": { prompt: true },
	// 	"Surveys": { prompt: true },
	// 	"Asbestos Reports": { prompt: true },
	// 	"Equipment Use Permits": { comingSoon: true },
	// 	"FDNY Permits (Annually Paid)": { comingSoon: true },
	// 	"Public Assembly": { comingSoon: true },
	// 	"Property Card": { comingSoon: true },
	// 	"Docket Book": { comingSoon: true },
	// 	"Tax Map": { comingSoon: true }
	// };
};
